import { Div, Header } from "@grassrootly/rn-core";
import { ScreenLayoutProps } from "./ScreenLayout.types";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import { StatusBar } from "expo-status-bar";
import { Platform, Text } from "react-native";
import Logo from "../logo/Logo";

type ScreenLayoutExtendedProps = ScreenLayoutProps & { centerContent?: boolean };

export default function ScreenLayout({
  children,
  header = false,
  footer = false,
  headerPaddingWeb = true,
  centerContent = true,
}: ScreenLayoutExtendedProps) {
  const insents = useSafeAreaInsets();
  
  // Default eqipa logo and text for header center
  const defaultHeaderCenter = (
    <Div classNames={["flexRow", "alignItemsCenter", "mt-{8}"]}>
      <Logo width={32} height={32} />
      <Text style={{ fontSize: 22, fontWeight: "bold", color: "#1ABC6C", marginLeft: 10 }}>
        eqipa
      </Text>
    </Div>
  );
  
  // Determine which header to use
  let headerToRender;
  if (header === false) {
    // No header provided, use default with eqipa branding
    headerToRender = { center: defaultHeaderCenter };
  } else if (typeof header === 'object' && header !== null) {
    // Custom header provided, always use eqipa branding for center (ignore custom center)
    headerToRender = {
      ...header,
      center: defaultHeaderCenter,
    };
  } else {
    // Function header
    headerToRender = header;
  }
  
  return (
    <Div classNames={["flex1", "minH-{100%}"]}>
      <StatusBar style="light" />
      {headerToRender ? typeof headerToRender === "function" ? headerToRender() : <Header {...headerToRender} /> : null}
      <Div classNames={["flex1", "minH-{100%}", "bgNeutralDarkerDark", centerContent ? "justifyContentCenter" : "justifyContentFlexStart"]}>
        <Div
          classNames={[
            "flex1",
            "maxW-{920}",
            "w-{100%}",
            "mr-{auto}",
            "ml-{auto}",
            "bgNeutralDarkerDark",
            `pr-{${insents.right + 16}}`,
            `pl-{${insents.left + 16}}`,
            footer ? "pb-{16}" : `pb-{${insents.bottom + 16}}`,
            header
              ? `pt-{${16 + (Platform.OS === "web" && headerPaddingWeb ? 65 : 0)}}`
              : `pt-{${insents.top + 16 + (Platform.OS === "web" && headerPaddingWeb ? 65 : 0)}}`,
          ]}
        >
          {children}
        </Div>
      </Div>
    </Div>
  );
}
